import React, { useEffect, useMemo, useState } from 'react'
import { useQuery } from 'convex/react'
import { api } from '../../convex/_generated/api'
// removed useAuth; using getCurrentUser query instead

const ClaimsPage: React.FC = () => {
  const currentUser = useQuery(api.auth.getCurrentUser)
  const [requesterId, setRequesterId] = useState<string | null>(null)
  useEffect(() => {
    if (currentUser && currentUser._id) {
      setRequesterId(currentUser._id)
    }
  }, [currentUser])
  const [statusFilter, setStatusFilter] = useState<string>('')
  const [typeFilter, setTypeFilter] = useState<string>('')
  const [search, setSearch] = useState<string>('')

  const claims = useQuery(api.claims.getClaims as any, requesterId ? {
    requesterId,
    status: statusFilter ? statusFilter : undefined,
    claimType: typeFilter ? (typeFilter as any) : undefined,
    limit: 100,
  } : 'skip') as any[] | undefined

  const filteredClaims = useMemo(() => {
    const list = claims || []
    if (!search) return list
    const s = search.toLowerCase()
    return list.filter(c =>
      (c.claimNumber || '').toLowerCase().includes(s) ||
      (c.policyNumber || '').toLowerCase().includes(s)
    )
  }, [claims, search])

  return (
    <div className="claims-page">
      <div className="page-header">
        <h1>Claims Management</h1>
        <p>Manage life and disability insurance claims</p>
      </div>

      <div className="claims-toolbar">
        <div className="search-filters">
          <input
            data-testid="search-input"
            type="text"
            placeholder="Search claims..."
            className="search-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <select
            data-testid="type-filter"
            className="filter-select"
            value={typeFilter}
            onChange={(e) => setTypeFilter(e.target.value)}
          >
            <option value="">All Claims</option>
            <option value="life">Life Insurance</option>
            <option value="disability">Disability Insurance</option>
          </select>
          <select
            data-testid="status-filter"
            className="filter-select"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="">All Statuses</option>
            <option value="new">New</option>
            <option value="investigating">Investigating</option>
            <option value="pending_docs">Pending Documents</option>
            <option value="approved">Approved</option>
            <option value="denied">Denied</option>
            <option value="closed">Closed</option>
          </select>
        </div>
        <a className="create-claim-button" href="/claims/new">
          <span className="button-icon">➕</span>
          New Claim
        </a>
      </div>

      <div className="claims-content">
        <table data-testid="claims-table" className="claims-table">
          <thead>
            <tr>
              <th>Claim #</th>
              <th>Policy #</th>
              <th>Type</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {(filteredClaims || []).map((c) => (
              <tr key={c._id} onClick={() => { window.location.href = `/claims/${c.claimNumber}` }}>
                <td>{c.claimNumber}</td>
                <td>{c.policyNumber}</td>
                <td>{c.claimType}</td>
                <td>{c.status}</td>
                <td>{new Date(c.createdAt).toLocaleDateString()}</td>
              </tr>
            ))}
            {(!filteredClaims || filteredClaims.length === 0) && (
              <tr>
                <td colSpan={5}>No claims found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default ClaimsPage